import { ServiceStateStrict } from 'state/service/app';
import { ServiceStateStrictWithEffects, TMClientAction } from './types';
import {
  abortWebsocketMessage,
  acceptWebsocketMessage,
  applyMessages,
  clearError,
  displayDecodeError,
  displayError,
  fetchHistoryFailed,
  fetchMoreHistory,
  initAppState,
  loadHistory,
  localAction,
  markHistoryItemsAsRead,
  rejectWebsocketMessage,
  sendChat,
  sendModel,
  setHistoryToggledOn,
  setIsReadOnly,
  setServerConnectionState,
  setTopic,
  websocketReady,
} from 'state/service/appTs/tmClientActions';
import { assertNever } from '@tock/shared/utils/typeUtils';

export function update(
  model: ServiceStateStrict,
  action: TMClientAction
): ServiceStateStrict | ServiceStateStrictWithEffects {
  switch (action.type) {
    case 'ClearError':
      return clearError(model);
    case 'DisplayDecodeError':
      return displayDecodeError(model, action.message);
    case 'DisplayError':
      return displayError(model, action.message);
    case 'MarkHistoryItemsAsRead':
      return markHistoryItemsAsRead(model);
    case 'InitAppState':
      return initAppState(model, action.initialModel);
    case 'SendModel':
      return sendModel(model);
    case 'SetIsReadOnly':
      return setIsReadOnly(model, action.isReadOnly);
    case 'SetHistoryToggledOn':
      return setHistoryToggledOn(model, action.toggledOn);
    case 'SetTopic':
      return setTopic(model, action.topicChangeRequest);
    case 'LocalAction':
      return localAction(model, action.timestampSecs, action.actions);
    case 'SendChat':
      return sendChat(model, action.timestampSecs, action.chatMessage);
    case 'ApplyMessages':
      return applyMessages(model, action.messages);
    case 'FetchMoreHistory':
      return fetchMoreHistory(model);
    case 'FetchHistoryFailed':
      return fetchHistoryFailed(model);
    case 'LoadHistory':
      return loadHistory(model, action.messagesAndDate);
    case 'SetServerConnectionState':
      return setServerConnectionState(model, action.serverConnectionState);
    case 'AcceptWebsocketMessage':
      return acceptWebsocketMessage(model);
    case 'RejectWebsocketMessage':
      return rejectWebsocketMessage(model);
    case 'AbortWebsocketMessage':
      return abortWebsocketMessage(model);
    case 'WebsocketReady':
      return websocketReady(model);
    default:
      return assertNever(action);
  }
}
